import React from 'react';

const CsrKpiCard = ({ label, value, sub }) => (
  <div className="csr-card csr-kpi">
    <span className="csr-kpi__label">{label}</span>
    <span className="csr-kpi__value">{value}</span>
    {sub ? <span className="csr-kpi__sub">{sub}</span> : null}
  </div>
);

export default CsrKpiCard;